import React, { Component } from 'react';
import AuthService from './AuthService';
import './Envelope.css';
import { find, isEqual } from 'lodash'
import ReactTooltip from 'react-tooltip';
import RoofReplacementPDF from '../pdf/RoofReplacement.pdf';
import WallInsulationPDF from '../pdf/WallInsulation.pdf';
import WindowReplacementPDF from '../pdf/WindowReplacement.pdf';
import DoorInsulationPDF from '../pdf/DoorInsulation.pdf';


import {
    Route,
    NavLink,
    HashRouter,
    Switch,
    Redirect,
    Link
} from "react-router-dom";

class Envelope extends Component {
  state = {
    data: [],
    focused: null
  }

  constructor (props) {
    super(props);
  }

  handleUserInput = (e) => {
    let update = {};
    //const replace = (name, r) => {
    //  return r + name.substr(1); //remove the first char from string
    //}
    if (e.target.value.length === 0) return false;
    
    const set = name => {
      const value = e.target.value;
      update[name] = parseInt(value)
    }
    const name = e.target.name;
    set(name) // coming from input name
    //set(replace(name, 'b')) // input name with first char = b
    // set(replace(name, 'c')) // input name with first char = c
    if(e.target.type === 'number') {
      const min = parseInt(e.target.getAttribute('min'));
      const max = parseInt(e.target.getAttribute('max'));
      const value = parseInt(e.target.value);
      console.log(min, max, value);
      
      if (value < min || value > max) return false;
    }
    this.props.onOptionsUpdate(update);
  }

  handleFocus = e => {
    this.setState({
      focused: e.target.id
    })
  }

  handleBlur = e => {
    this.setState({
      focused: null
    })
  }

  render() {
    // console.log(this.state.data);
    return (

      <div className="Envelope-Container">
        <div className="form-group">
          <label className="App-bold" htmlFor="aRoofRValue">Roof Replacement:</label> &nbsp;
           <input type="number"
            name="aRoofRValue"
            min="10"
            max="40"
            step="1"
            value={this.props.options.aRoofRValue}
            onChange={this.handleUserInput}
            className="roof-elem"
             /> &nbsp;<a data-class='tool_tip' data-tip="R-Value of the proposed new roof. Range = 10 to 40" target="_blank" href={RoofReplacementPDF}><i className="fas fa-question-circle green-icon"></i></a> 
             <ReactTooltip place="top" type="info" effect="solid"  />
        </div>

        <div className="form-group">
          <label className="App-bold" htmlFor="aWallRValue">Wall Insulation:</label> &nbsp;
           <input type="number"
            name="aWallRValue"
            min="10"
            max="30"
            step="1"
            value={this.props.options.aWallRValue}
            onChange={this.handleUserInput}
            className="wall-elem"
             /> &nbsp;<a data-tip="New R-Value of the walls. Range = 10 to 30" data-class='tool_tip' target="_blank" href={WallInsulationPDF}><i className="fas fa-question-circle green-icon"></i></a>
             <ReactTooltip place="top" type="info" effect="solid" />
        </div>

        <div className="form-group">
          <label className="App-bold" htmlFor="aWindowRValue">Window Replacement:</label> &nbsp;
           <input type="number"
            name="aWindowRValue"
            min="3"
            max="15"
            step="1"
            value={this.props.options.aWindowRValue}
            onChange={this.handleUserInput}
            className="window-elem"
             /> &nbsp;<a data-tip="R-Value of the proposed new windows. Range = 3 to 15" data-class='tool_tip' target="_blank" href={WindowReplacementPDF}><i className="fas fa-question-circle green-icon"></i></a>
             <ReactTooltip place="top" type="info" effect="solid" />
        </div>

        <div className="form-group">
          <label className="App-bold" htmlFor="aDoorRValue">Door Insulation:</label> &nbsp;
           <input type="number"
            name="aDoorRValue"
            min="3"
            max="15"
            step="1"
            value={this.props.options.aDoorRValue}
            onChange={this.handleUserInput}
            onFocus={this.handleFocus}
            onBlur={this.handleBlur}
            id="doorInsulation"
            disabled={this.state.focused === 'doorReplacement'}
            className="door-elem-in"
             /> &nbsp;<a data-tip="New R-Value of the new door or the door you added insulation. Range = 3 to 15" data-class='tool_tip' target="_blank" href={DoorInsulationPDF}><i className="fas fa-question-circle green-icon"></i></a>
             <ReactTooltip place="top" type="info" effect="solid" />
        </div>

        <div className="form-group hideDiv">
          <label className="App-bold" htmlFor="aDoorRValue">Door Replacement:</label> &nbsp;
           <input type="number"
            name="aDoorRValue"
            min="3"
            max="15"
            step="1"
            value={this.props.options.aDoorRValue}
            onChange={this.handleUserInput}
            onFocus={this.handleFocus}
            onBlur={this.handleBlur}
            id="doorReplacement"
            disabled={this.state.focused === 'doorInsulation'}
            className="door-elem-rep"
            /> &nbsp;<a data-tip="New R-Value of the new door or the door you added insulation. Range = 1 to 30" data-class='tool_tip' target="_blank" href={DoorInsulationPDF}><i className="fas fa-question-circle green-icon"></i></a>
            <ReactTooltip place="top" type="info" effect="solid" />
        </div>
      </div>

    );
  }
}

export default Envelope;


// WEBPACK FOOTER //
// ./src/components/Envelope.js